import { GridRow } from './grid-row';
import { GridContainer } from './grid-container';
import { GridColumn } from './grid-column';

export const Grid = {
  Container: GridContainer,
  Row: GridRow,
  Column: GridColumn,
};
